import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./dwsPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"
import { drawGrandTotal } from "./dwsdrawGrandTotalpdf";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);

  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



  drawGrandTotal(doc, grandTotal);


  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.DispReportType ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          dl: 0,
          ocl: 0,
          ds: 0,
          ocs: 0,
          total:0,
          

        },
      };
    }

    const dl = Number(row["DIRECT LABOUR"] || 0);
    const ds = Number(row["DIRECT STORE"] || 0);
    const ocl = Number(row["ON COST LABOUR"] || 0);
    const ocs = Number(row["ON COST STORE"] || 0);
    const total = dl+ds+ocl+ocs;



    groups[shop].rows.push(row);

    groups[shop].total.dl += dl;
    groups[shop].total.ds += ds;
    groups[shop].total.ocl += ocl;
    groups[shop].total.ocs += ocs;
    groups[shop].total.total += total;
    

    return groups;
  }, {});
}